/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Tabs as an underline, not a segmented pill.
 *
 * The vendor default was a grey pill with a white full-height indicator,
 * designed for a grey page. Every page here puts tabs on a white card, where
 * both vanished. This is the underline that layouts/analytics/styles.js used
 * to apply by hand, promoted to the theme so every page gets it.
 */

import colors from "assets/theme-dark/base/colors";
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { brand, outline, text } = colors;

const tabs = {
  defaultProps: {
    textColor: "inherit",
  },

  styleOverrides: {
    root: {
      position: "relative",
      minHeight: pxToRem(44),
      backgroundColor: "transparent",
      borderRadius: 0,
      padding: 0,
      borderBottom: `1px solid ${outline.variant}`,
    },
    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 1,
    },
    fixed: {},
    indicator: {
      height: pxToRem(2),
      bottom: 0,
      borderRadius: `${pxToRem(2)} ${pxToRem(2)} 0 0`,
      backgroundColor: brand.primary,
      boxShadow: "none",
      transition: "left 200ms ease, width 200ms ease",
    },
    vertical: {
      borderBottom: "none",
      borderRight: `1px solid ${outline.variant}`,
      "& .MuiTabs-indicator": {
        width: pxToRem(2),
        height: "auto",
        right: 0,
        left: "auto",
        borderRadius: `${pxToRem(2)} 0 0 ${pxToRem(2)}`,
      },
      "& .MuiTab-root": {
        alignItems: "flex-start",
        textAlign: "left",
        minHeight: pxToRem(40),
      },
    },
    scrollButtons: {
      width: pxToRem(32),
      color: text.focus,
      "&.Mui-disabled": {
        opacity: 0.25,
      },
      "& svg": {
        fontSize: pxToRem(20),
      },
    },
  },
};

export default tabs;
